<template>
	<inertia-head title="eBooks" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">eBooks</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Free ebooks for TRC members
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div v-if="user.current_rank == 'SILVER'">
			<div class="alert alert-warning">
				<p class="mb-0 fw-semibold">
					UPGRADE TO GOLD or HIGHER to view the Other Free Ebooks
				</p>
			</div>
		</div>
		<div class="mb-5 block block-rounded">
			<div class="block-content block-content-full">
				<h3>7 Success Principles (FREE eBook for Silver)</h3>
				<a
					href="/member/download/ebooks/7-Success-Principles.pdf" target="_blank"
					class="btn btn-alt-primary btn-lg"
				>
					<i class="fa fa-cloud-download-alt me-1"></i>
					Download
				</a>
			</div>
		</div>
		<div v-if="user.current_rank !== 'SILVER'" class="block block-rounded">
			<div class="block-content block-content-full">
				<h4>My Maid Invests In The Stock Market... And Why You Should Too. (Full Version)</h4>
				<a
					href="/member/download/ebooks/My-Maid-Invests-in-the-Stock-Market.pdf" target="_blank"
					class="btn btn-alt-primary btn-lg"
				>
					<i class="fa fa-cloud-download-alt me-1"></i>
					Download
				</a>
			</div>
			<div class="border-top block-content block-content-full">
				<h4>How To Turn Your Thoughts Into Things</h4>
				<a
					href="/member/download/ebooks/How-to-Turn-Thoughts-into-Things.pdf" target="_blank"
					class="btn btn-alt-primary btn-lg"
				>
					<i class="fa fa-cloud-download-alt me-1"></i>
					Download
				</a>
			</div>
			<div class="border-top block-content block-content-full">
				<h4>How To Conquer Your Goliath</h4>
				<a
					href="/member/download/ebooks/How-to-Conquer-your-Goliaths.pdf" target="_blank"
					class="btn btn-alt-primary btn-lg"
				>
					<i class="fa fa-cloud-download-alt me-1"></i>
					Download
				</a>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	props:{
		user : Object,

	},
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
